export enum BiteVictimType {
  ADULT = 'adult',
  CHILD = 'child',
}
